export default [
    {
      path: '',
      name: 'activityHome',
      meta: {
        title: '活动首页'
      },
      component: () => import('@/views/activity/index.vue')
    },
    {
      path: 'common-share',
      name: 'commonShare',
      meta: {
        title: '活动分享',
        activity: true
      },
      component: () => import('@/views/activity/common-share.vue')
    },
    {
      path: 'other-share',
      name: 'otherShare',
      meta: {
        title: '活动分享',
        activity: true
      },
      component: () => import('@/views/activity/other-share.vue')
    },
    {
      path: 'act-login',
      name: 'actLogin',
      meta: {
        title: '活动登录',
        activity: true
      },
      component: () => import('@/views/activity/login.vue')
    },
    {
      path: 'complete',
      name: 'complete',
      meta: {
        title: '完成活动',
        activity: true
      },
      component: () => import('@/views/activity/last-page.vue')
    },
    {
      path: 'activity-survey',
      name: 'activity-survey',
      meta: {
        title: '活动详情',
        activity: true
      },
      component: () => import('@/views/activity/activity-survey.vue')
    }
  ]